import Cookies from 'js-cookie';

export class User {
  getName() {
    return Cookies.get('user_name');
  }

  /**
   * Returns a company object with name and type.
   *
   * @returns {{
   *   name: string;
   *   type: 'manufacture' | 'service' | 'trading';
   * }}
   */
  getCompany() {
    return {
      name: Cookies.get('company_name'),
      type: Cookies.get('company_type'),
    };
  }
}
